import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Icon } from '@maui/elements'
import { StepNavigator } from '../common/StepNavigator'
import { useEodDrawer } from '../../providers/EodDrawerContext'
import { ServiceDetailsView } from '@nautilusjs/mati-shared'
import RequestsList from './RequestsList'
import { Loading } from './utils'
import { useFetchAllEodCases, useFetchEodCase } from '../../hooks'

export default function CurrentRequests() {
  const { dispatch: { showCurrentRequests }, maApiHost, authenticatedFetch, useQuery } = useEodDrawer()
  const [showServiceDetails, setShowServiceDetails] = useState()
  const { data, isLoading: casesLoading, isFetching, isError } = useFetchAllEodCases(useQuery, maApiHost, authenticatedFetch)
  const { data: caseData, isLoading: oneCaseLoading, isFetching: isFetchingCase, isError: isCaseError } = useFetchEodCase(useQuery, showServiceDetails?.id, maApiHost, authenticatedFetch)

  const handleShowServiceDetail = (data) => {
    if (data?.id) {
      setShowServiceDetails(data)
    }
  }

  const columns = useMemo(() => [
    {
      Header: 'Case Number',
      accessor: 'case_number',
    }
  ], [])

  return (
    <>
      <StepNavigator viewCurrentRequests={false}>
        <Box display="flex" alignItems="center" flexDirection="row" gap="spaceGapLarge">
          <Button variant="secondary" onClick={() => showServiceDetails ? setShowServiceDetails(undefined) : showCurrentRequests(false)}>
            <Box display="flex">
              <Icon name='left-arrow' size="sm" mr="10px" mt="1px" />
              Back
            </Box>
          </Button>
        </Box>
        {((oneCaseLoading && isFetchingCase) || (casesLoading && isFetching)) && <Loading />}
      </StepNavigator>

      <Box
        display={caseData ? 'none' : 'flex'}
        color="colorTextMain"
        flexDirection='column'
        minHeight='100%'
        justifyContent='space-between'
        gap='spaceGapSmall'
      >
        <RequestsList
          error={isError}
          data={data?.cases || []}
          totalCount={data?.total_count}
          columns={columns}
          loading={(oneCaseLoading && isFetchingCase)}
          handleShowServiceDetail={handleShowServiceDetail}
        />
      </Box>
      {caseData && <ServiceDetailsView data={caseData} error={isCaseError}/>}

    </>
  )
}

CurrentRequests.propTypes = {
  requests: PropTypes.array.isRequired,
}
